import { Tracker } from '@melio/penny';

import { PaymentDetailsProps } from '@/widgets/pay-dashboard/payment-details/PaymentDetails.types';
import { usePaymentTimelineTracker } from './usePaymentTimelineTracker';

export const PaymentTimelineTrackerSection = ({
  payment,
  children,
}: {
  payment: PaymentDetailsProps['payment'];
  children?: React.ReactNode;
}) => {
  const { shouldShowPaymentTimeLineTracker, steps, currentStepIndex } = usePaymentTimelineTracker(payment);

  if (!shouldShowPaymentTimeLineTracker) return null;

  return (
    <>
      <Tracker steps={steps} currentStepIndex={currentStepIndex} data-testid="payment-timeline-tracker" />
      {children}
    </>
  );
};
